import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'zc-label',
  templateUrl: './label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelComponent {}
